module.exports = __webpack_public_path__ + "static/img/three_icon_1.eb5460e9.png";